/**
 * 检测设备类型
 * @param ua User Agent字符串
 * @returns 设备类型
 */
export function getDeviceType(ua: string): string {
  const deviceTypePatterns = [
    { pattern: /mobile/i, type: 'Mobile' },
    { pattern: /tablet|ipad/i, type: 'Tablet' },
  ];

  const matched = deviceTypePatterns.find(({ pattern }) => pattern.test(ua));
  return matched?.type || 'PC';
}

/**
 * 检测操作系统
 * @param ua User Agent字符串
 * @returns 操作系统名称
 */
export function getOperatingSystem(ua: string): string {
  const osPatterns = [
    { pattern: /windows nt/i, os: 'Windows' },
    { pattern: /mac os/i, os: 'MacOS' },
    { pattern: /linux/i, os: 'Linux' },
    { pattern: /android/i, os: 'Android' },
    { pattern: /iphone|ipad|ipod/i, os: 'iOS' },
  ];

  const matched = osPatterns.find(({ pattern }) => pattern.test(ua));
  return matched?.os || 'Unknown';
}

/**
 * 检测设备品牌
 * @param ua User Agent字符串
 * @returns 设备品牌
 */
export function getDeviceBrand(ua: string): string {
  // 先检测操作系统，因为品牌检测依赖于OS
  const os = getOperatingSystem(ua);

  const brandPatterns = [
    { pattern: /windows nt/i, brand: 'Microsoft' },
    { pattern: /mac os|iphone|ipad|ipod/i, brand: 'Apple' },
    { pattern: /linux/i, brand: 'Open Source' },
  ];

  // 先尝试直接匹配
  const directMatch = brandPatterns.find(({ pattern }) => pattern.test(ua));
  if (directMatch) {
    return directMatch.brand;
  }

  // Android品牌特殊处理
  if (os === 'Android') {
    const androidBrands = [
      { pattern: /huawei|honor/i, brand: 'Huawei' },
      { pattern: /oppo/i, brand: 'Oppo' },
      { pattern: /vivo/i, brand: 'Vivo' },
      { pattern: /mi |redmi|xiaomi/i, brand: 'Xiaomi' },
      { pattern: /samsung/i, brand: 'Samsung' },
    ];

    const matchedBrand = androidBrands.find(({ pattern }) => pattern.test(ua));
    return matchedBrand?.brand || 'Android Device';
  }

  return 'Unknown';
}

/**
 * 获取设备信息
 * @returns {Object} 设备信息
 */
export function getDeviceInfo() {
  const ua = navigator.userAgent.toLowerCase();

  return {
    deviceType: getDeviceType(ua),
    os: getOperatingSystem(ua),
    deviceBrand: getDeviceBrand(ua),
  };
}
